import { render } from "./OnlineBanking.vue?vue&type=template&id=5d80473c&scoped=true&ts=true"
import script from "./OnlineBanking.vue?vue&type=script&lang=ts"
export * from "./OnlineBanking.vue?vue&type=script&lang=ts"

import "./OnlineBanking.vue?vue&type=style&index=0&id=5d80473c&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d80473c"]])

export default __exports__